import { createFileRoute, Outlet } from '@tanstack/react-router';
import { ProductLogoMediumIDs } from '@/components/Logo';
import type { TabWithIndicatorProps } from '@/components/Navigation/HeaderTabs';
import { ProductHeader } from '@/components/ProductHeader';
import useDocumentTitle from '@/hooks/useDocumentTitle';
import { useTranslation } from '@/lib/i18n';
export const Route = createFileRoute('/_staff/ids/_layout')({
  component: Layout
});
function Layout() {
  const {
    t
  } = useTranslation();
  useDocumentTitle(t('pages.idManagements.list.pageTitle'));
  const tabs = [{
    to: '/ids/overview',
    children: t('common.list.overview'),
    activeOptions: {
      exact: true
    }
  }, {
    to: '/ids',
    children: t('common.list.idLists'),
    activeOptions: {
      exact: true,
      includeSearch: true
    }
  }, {
    to: '/ids/group-id',
    children: t('common.list.groupId'),
    activeOptions: {
      exact: true,
      includeSearch: true
    }
  }, {
    to: '/ids/people',
    children: t('common.list.people'),
    activeOptions: {
      exact: true,
      includeSearch: true
    }
  }, {
    to: '/ids/alerts',
    children: t('common.list.alerts'),
    activeOptions: {
      exact: true,
      includeSearch: false
    }
  }, {
    to: '/ids/rule-and-policy',
    children: t('common.list.ruleAndPolicy'),
    activeOptions: {
      exact: true,
      includeSearch: false
    }
  }, {
    to: '/ids/operation-activity',
    children: t('common.list.operationActivity')
  }, {
    to: '/ids/settings',
    children: t('common.list.settings'),
    activeOptions: {
      exact: true,
      includeSearch: false
    }
  }] satisfies TabWithIndicatorProps[];
  return <div className="flex flex-col">
      <ProductHeader Logo={ProductLogoMediumIDs} name={t('pages.idManagements.list.pageTitle')} tabs={tabs} type="resource" />
      <Outlet />
    </div>;
}